















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Types
import { IProduct } from "@/models/products";

@Component
export default class DueDateRestrictionField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: IProduct["due_date_restriction"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public isRestricted = false;
  public savedValue: IProduct["due_date_restriction"] = 1;

  public created() {
    this.isRestricted = !this.$_.isNull(this.value);
    this.savedValue = this.isRestricted ? this.value : 1;
  }

  // Getters

  public get dueDateRestriction() {
    return this.value;
  }

  public isRestrictedChanged() {
    this.$emit("input", this.isRestricted ? this.savedValue : null);
  }

  // Watchers

  @Watch("dueDateRestriction")
  public onDueDateRestrictionChange(value, oldValue) {
    this.savedValue = oldValue;
  }

  @Watch("value")
  public onPassedValueChange() {
    this.isRestricted = !this.$_.isNull(this.value);
  }
}
